import React from "react";
import { Panel } from "@/components/common/Panel";
import { SeverityBadge, StatusBadge } from "@/components/common/Badges";
import { TID } from "@/lib/testIds";

export function FindingsTab({ findings }) {
    return (
        <Panel eyebrow={`${findings.length} detections`} title="Engineering Findings">
            <table className="tbl">
                <thead>
                    <tr>
                        <th>Severity</th>
                        <th>Title</th>
                        <th>Category</th>
                        <th>Engine</th>
                        <th>Confidence</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {findings.length === 0 && <tr><td colSpan={6} className="text-center text-xs text-slate-500 font-mono py-6">Run analysis to populate findings.</td></tr>}
                    {findings.map((f) => (
                        <tr key={f.id} data-testid={TID.findingRow(f.id)}>
                            <td><SeverityBadge severity={f.severity} /></td>
                            <td className="max-w-[360px]">{f.title}</td>
                            <td className="text-slate-400">{f.category}</td>
                            <td className="font-mono text-[11px] uppercase text-cyan-300/80">{f.engine}</td>
                            <td className="font-mono text-cyan-300">{Math.round((f.confidence || 0) * 100)}%</td>
                            <td><StatusBadge status={f.status} /></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </Panel>
    );
}
